/* INNOVATIVE v2 — scroll reveal (staggered fade-up), in the style of apple.com.
   Safe by design: nothing is hidden unless this script runs, the browser supports
   IntersectionObserver, and the visitor has not asked for reduced motion.
   Content already on screen at load is never hidden. Product stories are skipped. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return; // keep the theme editor static

  var SEL = [
    '.lo-section .lo-eyebrow', '.lo-section .lo-h2', '.lo-section .lo-lead',
    '.lo-section .lo-section-head .lo-link', '.lo-section .lo-actions',
    '.lo-card', '.lo-priv__card', '.lo-review', '.lo-promise', '.lo-faq__item',
    '.lo-guide', '.lo-split__media', '.lo-split__copy .lo-details',
    '.lo-video__frame', '.lo-trust__list li', '.lo-more__item',
    '.lo-collection-intro__head > *', '.product-grid__item'
  ].join(',');

  var vh = window.innerHeight || 800;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function prep(root) {
    var els = (root || document).querySelectorAll(SEL);
    var groups = new Map();
    els.forEach(function (el) {
      if (el.hasAttribute('data-lo-reveal')) return;
      if (el.closest('.lo-story, .lo-hero, .lo-topbar, header, .cart-drawer, dialog')) return;
      if (el.getBoundingClientRect().top < vh) return; // already visible: never hide it
      var parent = el.parentElement;
      var n = groups.get(parent) || 0;
      groups.set(parent, n + 1);
      el.style.setProperty('--lo-d', Math.min(n, 6) * 80 + 'ms'); // stagger siblings
      el.setAttribute('data-lo-reveal', '');
      io.observe(el);
    });
  }

  document.documentElement.classList.add('lo-reveal-on');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { prep(); });
  else prep();

  // Grids that re-render (filters, sorting, load more) get the same treatment.
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { vh = window.innerHeight || vh; prep(); break; }
  }).observe(document.body, { childList: true, subtree: true });
})();
